import Vue from 'vue';
// import _ from 'lodash';
// import {router} from '../../router';
// import {i18n} from '../../plugins/i18n';

export default {
  state: {
    coreParams: null,
    shopId: null,
    countryOptions: null,
    prevRoute: null,
    isAlertShown: null,
    renderAlbum: true,
  },
  getters: {
    CORE_PARAMS: state => {
      return state.coreParams;
    },
    SHOP_ID: state => {
      return state.shopId;
    },
    RENDER_ALBUM: state => {
      return state.renderAlbum;
    },
    COUNTRY_OPTIONS: state => {
      return state.countryOptions;
    },
    PREV_ROUTE: state => {
      return state.prevRoute;
    },
    IS_ALERT_SHOWN: state => {
      return state.isAlertShown;
    },
  },
  mutations: {
    SET_CORE_PARAMS: (state, payload) => {
      state.coreParams = payload;
    },
    SET_SHOP_ID: (state, payload) => {
      state.shopId = payload;
    },
    SET_COUNTRY_OPTIONS: (state, payload) => {
      state.countryOptions = payload;
    },
    SET_PREV_ROUTE: (state, payload) => {
      state.prevRoute = payload;
    },
    SET_ALERT_SHOWN: (state, payload) => {
      state.isAlertShown = payload;
    },
    SET_RENDER_ALBUM: (state, payload) => {
      state.renderAlbum = payload;
    },
  },
  actions: {
    INIT_COUNTRY_OPTIONS: async (context) => {
      const countries = await Vue.axios.get('countries');
      context.commit('SET_COUNTRY_OPTIONS', countries.data.data);
    },
    SET_CORE_PARAMS: async (context) => {
      const shopParams = JSON.parse(localStorage.getItem('shop'));

      Vue.axios.interceptors.request.use(config => {
        config.headers['X-shop'] = shopParams.id;
        config.headers['X-shop-domain'] = context.getters.SHOP_ID;

        if (localStorage.getItem('private-tags')) {
          config.headers['X-bk-tags'] = localStorage.getItem('private-tags');
        }

        return config;
      });

      context.commit('SET_SHOP_ID', shopParams.domain);
      context.commit('SET_CORE_PARAMS', shopParams);

      /*const notFoundRoute = `/${i18n.locale}/404`;
      const loader = Vue.$loading.show({opacity: 1});

      try {
        context.dispatch('GET_SHOP_ID');

        const url = 'shops/get_by_name';
        const response = await Vue.axios.post(url,
            {domain: context.state.shopId});

        loader.hide();

        if (response.data.success) {
          let shopParams = response.data.data;

          shopParams.theme = 'premium';
          shopParams.theme_color = 'light';
          shopParams.sidebar = false;

          Vue.axios.interceptors.request.use(config => {
            config.headers['X-shop'] = shopParams.id;
            config.headers['X-shop-domain'] = context.getters.SHOP_ID;
            return config;
          });

          context.commit('SET_CORE_PARAMS', shopParams);
        } else {
          context.commit('SET_SHOP_ID', null);
          if (router.currentRoute.path !== notFoundRoute) {
            router.push(notFoundRoute);
          }
        }
      } catch (e) {
        context.commit('SET_SHOP_ID', null);
        loader.hide();

        if (router.currentRoute.path !== notFoundRoute) {
          router.push(notFoundRoute);
        }
      }*/
    },
    SET_PREV_ROUTE: (context, prevRoute) => {
      context.commit('SET_PREV_ROUTE', prevRoute);
    },
    SET_ALERT_SHOWN: (context, isAlertShown) => {
      context.commit('SET_ALERT_SHOWN', isAlertShown);
    },
    SET_RENDER_ALBUM: (context, renderAlbum) => {
      context.commit('SET_RENDER_ALBUM', renderAlbum);
    },
  },
};